import { processAssetData } from '@utils/assethelper'
import { getConfig } from '@configs/evnConfig'
import {
  FETCH_URL,
  DEFAULT_CHALLAN,
  APPFLYER_SEM_PMAX,
  APPFLYER_SEO,
  SEO_CHALLAN_PAGE,
  UTM_LEAD,
} from '@components/MainWidget/common/commonConstants'
import { VEHICLE_DATA } from '@components/MainWidget/ChallanWidgetLanding/constants'
import { UtmLeadProductType } from '@enums/UtmLeadProduct'

export const getVehicleMMVStoreData = async challanUserData => {
  const assetImageResponse = await processAssetData(challanUserData?.vehicleInfo, FETCH_URL)
  const encodedData = btoa(
    JSON.stringify({ ...challanUserData, logo_url: assetImageResponse?.variantDetails?.logo_url })
  )
  localStorage.setItem(VEHICLE_DATA, encodedData)
  return 0
}

export const fetchDataFromLS = () => {
  const storedData = localStorage.getItem(VEHICLE_DATA)
  if (storedData) {
    try {
      const decodedString = atob(storedData)
      const parsedData = JSON.parse(decodedString)
      return parsedData
    } catch (err) {
      console.error('Failed to decode or parse stored vehicleData:', err)
      localStorage.removeItem(VEHICLE_DATA)
    }
  } else return null
}

export const getUtmLead = () => {
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get(UTM_LEAD) || ''
  }
  return ''
}

export const getProductName = () => {
  const utmLead = getUtmLead()

  const productMapping = {
    [UtmLeadProductType.SEM_CHALLAN]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.PMAX_CHALLAN]: UtmLeadProductType.PMAX_CHALLAN,
    [UtmLeadProductType.META_CHALLAN]: UtmLeadProductType.META_CHALLAN,
  }

  return productMapping[utmLead] || DEFAULT_CHALLAN
}

export const getSourceName = () => {
  const utmLead = getUtmLead()

  const productMapping = {
    [UtmLeadProductType.SEM_CHALLAN]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.PMAX_CHALLAN]: UtmLeadProductType.PMAX_CHALLAN,
    [UtmLeadProductType.META_CHALLAN]: UtmLeadProductType.META_CHALLAN,
  }

  return productMapping[utmLead] || SEO_CHALLAN_PAGE
}

export const getApiKeyLead = currentEnv => {
  const utmLead = getUtmLead()

  const productMapping = {
    [UtmLeadProductType.SEM_CHALLAN]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.PMAX_CHALLAN]: UtmLeadProductType.PMAX_CHALLAN,
    [UtmLeadProductType.META_CHALLAN]: UtmLeadProductType.META_CHALLAN,
    [UtmLeadProductType.SEO_CHALLAN]: UtmLeadProductType.SEO_CHALLAN,
  }

  if (utmLead && productMapping[utmLead]) {
    return getConfig(currentEnv)?.autoVasConfig?.apiKeySem[productMapping[utmLead]]
  }
  return getConfig(currentEnv)?.autoVasConfig?.apiKeyWithouUtm
}

export const getFallBackQRDownloadUrl = () => {
  const utmLead = getUtmLead()

  const productMapping = {
    SEM_CHALLAN: APPFLYER_SEM_PMAX,
    PMAX_CHALLAN: APPFLYER_SEM_PMAX,
    META_CHALLAN: APPFLYER_SEM_PMAX,
  }

  return productMapping[utmLead] || APPFLYER_SEO
}
